<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: scroll" tabindex="-1" @click="onClose">
      <div class="modal-dialog modal-md modal-dialog-centered" @click.stop="">
        <div class="modal-content">
          <div class="modal-header">
            <span>Edit Incident #{{ incident.id }}</span>
            <button @click="onClose" type="button" class="close" aria-label="Close">×</button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Incident Type</label>
              <select v-model="form.incidentType" class="form-control">
                <option value="cancellation">Cancellation (before pickup window)</option>
                <option value="cancellation_24h">Cancellation (within 24h of pickup)</option>
                <option value="no_show">No-show (after pickup window)</option>
                <option value="ghosting">Ghosting (accepted, never answered)</option>
                <option value="late_pickup">Late pickup</option>
                <option value="late_delivery">Late delivery</option>
                <option value="communication">Failure to provide updates</option>
                <option value="false_status">False status update</option>
                <option value="damage">Damage (minor / moderate)</option>
                <option value="damage_severe">Damage (severe / unresolved)</option>
              </select>
            </div>

            <div class="form-group">
              <label>Responsibility</label>
              <select v-model="form.responsibility" class="form-control">
                <option value="carrier_fault">Carrier fault</option>
                <option value="broker_company_fault">Broker / Company fault</option>
                <option value="customer_shipper_fault">Customer / Shipper fault</option>
                <option value="mutual_agreement">Mutual agreement</option>
                <option value="admin_mistake">Admin mistake</option>
                <option value="unknown_review">Unknown / needs review</option>
              </select>
            </div>

            <div class="form-group">
              <label>Severity (used for damage incidents)</label>
              <select v-model="form.severity" class="form-control">
                <option :value="null">- none -</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </select>
            </div>

            <div class="form-group">
              <label>Score Impact</label>
              <input v-model.number="form.scoreImpact" type="number" min="-100" max="0" class="form-control" />
              <small class="text-muted">Negative number, 0 to -100. E.g. -10 for cancellation.</small>
            </div>

            <div class="form-group">
              <label>Notes</label>
              <textarea v-model="form.notes" class="form-control" rows="3" />
            </div>

            <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="onClose">Cancel</button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="saving"
              @click="save"
            >{{ saving ? 'Saving...' : 'Save changes' }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';

export default {
  name: 'CarrierIncidentEditModal',
  props: {
    incident: { type: Object, required: true },
    onClose: { type: Function, default: () => {} },
  },
  data() {
    return {
      saving: false,
      error: '',
      form: {
        incidentType: this.incident.incidentType,
        responsibility: this.incident.responsibility,
        severity: this.incident.severity || null,
        scoreImpact: this.incident.scoreImpact,
        notes: this.incident.notes || '',
      },
    };
  },
  methods: {
    async save() {
      this.saving = true;
      this.error = '';
      const response = await ApiClient.carrierIncidents.put({
        id: this.incident.id,
        body: this.form,
      });
      this.saving = false;
      if (response.status === 200) {
        this.$emit('saved', response.data.data);
      } else if (response.status === 403) {
        this.error = 'Only admin/manager can edit incidents.';
      } else if (response.status === 422) {
        const first = response.data.errors ? Object.values(response.data.errors)[0] : null;
        this.error = (first && first[0]) || 'Validation failed';
      } else if (response.status === 400) {
        this.error = response.data.message || 'Save failed';
      } else {
        this.error = 'Unexpected error';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.outter-modal {
  position: absolute;
  z-index: 1089;
}
</style>
